import React, { useEffect } from 'react';
import { Flex, Modal } from '@certilogo/design-system-web';
import LoadingIndicator from 'components/LoadingIndicator';
import { selectQueryParams } from 'containers/App/selectors';
import { loginRequest, setProfileEbayRequest } from 'containers/Auth/actions';
import { selectIsAuthenticated } from 'containers/Auth/selectors';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

function Callback({ setError }) {
  const colorType = 'dark';
  const dispatch = useDispatch();
  const params = useSelector(selectQueryParams);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (params?.code) {
      if (isAuthenticated) {
        dispatch(
          setProfileEbayRequest({
            code: params.code,
            redirect: true,
          }),
        );
      } else {
        dispatch(
          loginRequest({
            network: 'ebay',
            code: params.code,
            redirect: true,
          }),
        );
      }
    } else {
      setError('ebay');
    }
  }, [params]);

  return (
    <Modal
      colorType={colorType}
      isOpen
      fullScreen
      modalStyle={{ borderRadius: '0' }}
      disableAnimation
    >
      <Wrapper>
        <LoadingIndicator colorType={colorType} />
      </Wrapper>
    </Modal>
  );
}

Callback.propTypes = {
  setError: PropTypes.func,
};

export default Callback;
